module.exports = __webpack_public_path__ + "jurvansanomat_logo-36daa91d2cab2896be56.png";